import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CampaignModel } from '@modules/campaigns/models/campaign.model';

@Injectable({ providedIn: 'root' })
export class CampaignContextService {
  private campaignSubject = new BehaviorSubject<CampaignModel | null>(null);
  campaign$ = this.campaignSubject.asObservable();

  setCampaign(campaign: CampaignModel) {
    this.campaignSubject.next(campaign);
  }

  getCampaign(): CampaignModel | null {
    return this.campaignSubject.value;
  }

  clearCampaign() {
    this.campaignSubject.next(null);
  }
}
